import styled, { css } from 'styled-components'

import {
  _S_Bold,
  _XS_Bold,
  _XS_Medium,
  _XS_Normal,
  mainColors,
  semanticColors,
} from '@avantstay/backoffice-core'

export type CaseTone = 'hot' | 'warm'

const tones = {
  hot: css`
    border-left-color: ${semanticColors.failureDark};
    background: ${semanticColors.failureExtraLight};
  `,
  warm: css`
    border-left-color: ${semanticColors.warningExtraDark};
    background: ${semanticColors.warningExtraLight};
  `,
}

export const Root = styled.div<{ $tone: CaseTone }>`
  border-left: 3px solid transparent;
  border-radius: 0 8px 8px 0;
  padding: 8px 12px;
  margin: 16px 0;
  ${({ $tone }) => tones[$tone]};
`

export const Head = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;

  svg {
    width: 12px;
    height: 12px;
    flex: none;
  }
`

export const Label = styled.span<{ $tone: CaseTone }>`
  ${_XS_Bold};
  letter-spacing: 0.06em;
  color: ${({ $tone }) =>
    $tone === 'hot' ? semanticColors.failureDark : semanticColors.warningExtraDark};
`

export const Glyph = styled.span<{ $tone: CaseTone }>`
  display: inline-flex;
  color: ${({ $tone }) =>
    $tone === 'hot' ? semanticColors.failureDark : semanticColors.warningExtraDark};
`

export const Spacer = styled.span`
  flex: 1;
`

export const Link = styled.a`
  ${_XS_Medium};
  color: ${mainColors.accentDark};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`

export const Subject = styled.div`
  ${_S_Bold};
  color: ${mainColors.primaryMedium};
  margin-top: 4px;
  overflow-wrap: anywhere;
`

export const Meta = styled.div`
  ${_XS_Normal};
  color: ${mainColors.neutralExtremelyDark2};
  margin-top: 4px;
  overflow-wrap: anywhere;
`
